import FeeForm from '../../../../components/Purchasing/Order/Fee/FeeForm'
import ReadyToCollect from '../../../../components/Purchasing/Order/Fee/ReadyToCollect'
import { strVal } from '../../../../modules/Utils'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function FeeModal (props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    order,
    line,
    isUpdatable,
  } = props

  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Purchase Order Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'PO Lines'}
          isNew={isNew}
          isEdit={!isNew}>
          {strVal(order, 'type') !== 'Freight Booking' && <ReadyToCollect {...{ order, line }} />}
        </FooterButtons>
      }
      width={'75%'}>
      <FeeForm ref={formRef} {...props} />
    </Modal>
  )
}

export default FeeModal
